import React, { useEffect, useState } from 'react';
import constants from '../../const';
import ImageAlbumCover from '../gallery/image-album-cover';
import axios from 'axios';
import '../gallery/gallery.css';

function ActorGallery(props) {

    const [galleries, setGalleries] = useState(null);
    const [viewMode, setViewMode] = useState('large'); // 'large', 'medium', 'compact'
    var token = `?token=${localStorage.getItem('token').slice(7)}`;

    const fetchGalleries = () => {
        if (localStorage.getItem('token') != null) {
            axios.get(`${constants.CONTENT_DOMAIN}files/directory/galleries${token}`).then(
                res => {
                    setGalleries(res.data);
                }
            ).catch(err => {
                console.log(err);
            });
        }
    }    
    
    useEffect(()=>{
        fetchGalleries();
        
    },[])
    
    useEffect(()=>{
        if(galleries!=null){
        }
    },[galleries])

  
        return (
            <div style={{ position: 'relative' }}>
            <div className="gallery-view-toggle">
                <label>View:</label>
                <div className="view-toggle-buttons">
                    <button 
                        className={`view-toggle-btn ${viewMode === 'large' ? 'active' : ''}`}
                        onClick={() => setViewMode('large')}
                    >
                        Large
                    </button>
                    <button 
                        className={`view-toggle-btn ${viewMode === 'medium' ? 'active' : ''}`}
                        onClick={() => setViewMode('medium')}
                    >
                        Medium
                    </button>
                    <button 
                        className={`view-toggle-btn ${viewMode === 'compact' ? 'active' : ''}`}
                        onClick={() => setViewMode('compact')}
                    >
                        Compact
                    </button>
                </div>
            </div>
            <div className={`gallery-grid-${viewMode}`}>
                {galleries!=null?<>{
                    galleries.map(gal=>{
                        return <ImageAlbumCover src={`${constants.CONTENT_DOMAIN}download/sus-media/galleries/${gal.name}/preview.webp${token}`} link={`/gallery/${gal.name}`} key={gal.name} gal={gal.name} size={viewMode}/>
                    })
                }</>:<></>}
            </div>
            </div>
        )
}

export default ActorGallery;